"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var topPos = ["top-start", "top", "top-end"];
var bottomPos = ["bottom-start", "bottom", "bottom-end"];
var startPos = ["start"];
var endPos = ["end"];
var order = {
    top: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], topPos, true), bottomPos, true), endPos, true), startPos, true),
    bottom: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], bottomPos, true), topPos, true), endPos, true), startPos, true),
    start: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], startPos, true), endPos, true), topPos, true), bottomPos, true),
    end: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], endPos, true), startPos, true), topPos, true), bottomPos, true),
};
/**
 * Get an order of positions to try to fit popover on the screen based on its starting position
 */
var getPositionOrder = function (position) {
    var _a;
    var types = ["top", "bottom", "start", "end"];
    var type = (_a = types.find(function (type) { return position.startsWith(type); })) !== null && _a !== void 0 ? _a : "bottom";
    return order[type];
};
exports.default = getPositionOrder;
